import options from './connectivity-chart.component';

export default {
    selector: 'dtConnectivityChart',
    options
};
